import { createLucideIcon } from "lucide-react";

export const ChevronLeft = createLucideIcon(
    "ChevronLeft",
    [
        [
            "path",
            {
                d: "M15 6L9.70711 11.2929C9.37377 11.6262 9.20711 11.7929 9.20711 12C9.20711 12.2071 9.37377 12.3738 9.70711 12.7071L15 18",
                key: "1xxb1f",
            },
        ],
    ],
);
